const legs = [
  {
    code: 'ST-01',
    name: 'Discovery',
    happens:
      'We map your domain, existing systems, constraints, and success criteria with your stakeholders.',
    receives:
      'A scoped architecture outline, delivery plan, and explicit assumptions — before any build commitment.',
  },
  {
    code: 'ST-02',
    name: 'Build',
    happens:
      'Senior engineers lead implementation with AI-assisted velocity on scaffolding, tests, and integration glue.',
    receives:
      'Working increments in your environment, with review checkpoints and visible progress against the agreed scope.',
  },
  {
    code: 'ST-03',
    name: 'Handover',
    happens:
      'We finalize deployment pipelines, observability, documentation, and knowledge transfer to your team.',
    receives:
      'Production-ready systems with runbooks, source access, and a clean handoff — not a dependency on us.',
  },
]

/**
 * Traverse profile — a vertical section drawing with stations along one rule,
 * not a third copy of the label/text/text table.
 */
export function Traverse() {
  return (
    <section id="traverse" className="bg-sheet">
      <div className="mx-auto max-w-[100rem] px-6 py-12 lg:px-8 lg:py-16">
        <div className="mb-8 flex flex-col gap-2 border-b-2 border-ink pb-4 sm:flex-row sm:items-end sm:justify-between">
          <h2 className="section-title text-ink">How we work</h2>
          <p className="text-sm leading-relaxed text-ink-muted sm:max-w-sm sm:text-right">
            One traverse from first conversation to production handover.
          </p>
        </div>

        <div className="relative">
          {/* Vertical traverse rule */}
          <div
            className="absolute bottom-4 left-[1.125rem] top-4 w-px bg-ink lg:left-8"
            aria-hidden="true"
          />
          <div
            className="absolute bottom-4 left-[1.125rem] top-4 w-px border-l border-dashed border-overprint lg:left-8"
            aria-hidden="true"
          />

          <ol className="space-y-0">
            {legs.map((leg) => (
              <li
                key={leg.code}
                className="relative grid gap-4 py-6 pl-12 lg:grid-cols-[10rem_1fr_1fr] lg:gap-10 lg:py-7 lg:pl-20"
              >
                <span
                  className="absolute left-[0.55rem] top-8 flex h-5 w-5 items-center justify-center rounded-full border-[1.5px] border-ink bg-sheet lg:left-[1.45rem] lg:top-9"
                  aria-hidden="true"
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-overprint" />
                </span>

                <div>
                  <span className="datum block text-overprint">{leg.code}</span>
                  <h3
                    className="entry-title mt-1.5 text-ink"
                    style={{ fontStretch: '80%' }}
                  >
                    {leg.name}
                  </h3>
                </div>

                <div>
                  <p className="cell-label mb-2 text-ink-muted">What happens</p>
                  <p className="text-[0.9375rem] leading-relaxed text-ink-muted">
                    {leg.happens}
                  </p>
                </div>

                <div>
                  <p className="cell-label mb-2 text-ink-muted">What you receive</p>
                  <p className="text-[0.9375rem] leading-relaxed text-ink-muted">
                    {leg.receives}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  )
}
